/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabTestCategoryGroup from './lab-test-category-group';
import LabTestCategoryGroupDetail from './lab-test-category-group-detail';
import LabTestCategoryGroupUpdate from './lab-test-category-group-update';
import LabTestCategoryGroupDeleteDialog from './lab-test-category-group-delete-dialog';

const LabTestCategoryGroupRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabTestCategoryGroup />} />
    <Route path="new" element={<LabTestCategoryGroupUpdate />} />
    <Route path=":id">
      <Route index element={<LabTestCategoryGroupDetail />} />
      <Route path="edit" element={<LabTestCategoryGroupUpdate />} />
      <Route path="delete" element={<LabTestCategoryGroupDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabTestCategoryGroupRoutes;
